import { DependenciesInjection } from "app/di/DependencyInjection";
import { PermissionDataImpl } from "../data/PermissionDataImpl";
import { IPermissionDataRepository } from "../domain/repositories/IPermissionDataRepository";
import { PermissionDataUseCase } from "../domain/useCases/PermissionDataUseCase";
import { PermissionDataViewModel } from "../presentation/viewModel/PermissionDataViewModel";
import { PermissionDataToken } from "./PermissionDataToken";

export class PermissionDataInjection {
  static initInjections() {
    DependenciesInjection.register<IPermissionDataRepository>(
      PermissionDataToken.IPermissionDataRepository,
      PermissionDataImpl,
      "otherRepo",
    );
    DependenciesInjection.register<PermissionDataUseCase>(
      PermissionDataToken.PermissionDataUseCase,
      PermissionDataUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<PermissionDataViewModel>(
      PermissionDataToken.PermissionDataViewModel,
      PermissionDataViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IPermissionDataRepository>(
      PermissionDataToken.IPermissionDataRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<PermissionDataUseCase>(
      PermissionDataToken.PermissionDataUseCase,
    );
  }
}
